import GoogleChartContainer from "../../../Components/Charts/GoogleChart/GoogleChartContainer";

const GoogleChart = () => {
  return <GoogleChartContainer />;
};

export default GoogleChart;
